import { render } from "./SearchIcon.vue?vue&type=template&id=28896cc5&scoped=true"
const script = {}

import "./SearchIcon.vue?vue&type=style&index=0&id=28896cc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28896cc5"]])

export default __exports__